import MfdAumGrowth, {buildImpetusLandingProps} from "./index";

export default MfdAumGrowth;

function pickLangParam (...candidates) {
  for (const c of candidates) {
    const v = Array.isArray(c) ? c[0] : c;
    if (v === "en" || v === "hi") {
      return v;
    }
  }
  return null;
}

export async function getServerSideProps ({params, query}) {
  const lang = pickLangParam(params?.lang, query?.lang, query?.nxtPlang);

  if (!lang) {
    return {
      notFound: true
    };
  }

  return buildImpetusLandingProps(lang);
}
